/***
 * 更多服务
 *  */
// 定制逻辑处理
export default {
  // 轨迹回推日志 菜单定制展示
  trajectory_log_menu_show: ["82635",'82622','82964','88407', '52745','60892','60893','62853','69903','70683','72278','75602','75657','75868','77997','78210','78556','78732','78762','79027','79388','79866','81175','81817','81819','82156','82622','82964','82994','83043','83644','85156','85752','85759','86609','86986','87189','87393','87538','87560','87959','88206','88326','88407','88660','88934','89126','90030','90526','90567','90597','90782','90890','91032','91270','91720','93585','93705','93726','96578','98321','98380','99671','99672','61839'], // 202511181645153634826
}
